// src/components/Assets/Templates/Normal1/normal1.js
export default `
  
<!doctype html>
<html ⚡4email data-css-strict>
<head>
<meta charset="utf-8">
<title>Srihari Muppalla</title>
<script async src="https://cdn.ampproject.org/v0.js"></script> 
<script async custom-element="amp-accordion" src="https://cdn.ampproject.org/v0/amp-accordion-0.1.js"></script>
<script async custom-element="amp-carousel" src="https://cdn.ampproject.org/v0/amp-carousel-0.1.js"></script>
<style amp4email-boilerplate>
body {
visibility: hidden
}
</style>
<style amp-custom>
.header{
cursor: pointer;
background-color: #BB7AEC;
padding: 10px 0px;
text-align: center;
}
.tog{
cursor: pointer;
display: block;
background-image: url('https://cdn0.iconfinder.com/data/icons/google-material-design-3-0/48/ic_add_circle_48px-512.png');
background-repeat: no-repeat;
background-size: 26px auto;
background-position: 96% 50%;
}
.cont{
color: #ffffff;
padding: 10px 30px;
font-size: 18px;
font-family: "Times New Roman", "serif";
}
.sec3-img{
margin-right: 20px;
}

#s1{display: none;}

@media only screen and (max-width: 580px) {
.w100 {
width: 100%;
}
.wid320 {
width: 320px;
}
.h{display: none;}
.show{display: block;}
.sec3-img{
margin-right: 0px; margin-bottom: 20px;
}
.mob{float: left; display: block; width: 100%;}

}

@media only screen and (max-width: 480px) {
.w100 {
width: 100%;
}
.mob{float: left; display: block; width: 100%;}
.h{display: none;}
.show{display: block;}
#s1{display: block;}


}
</style>
</head>
<body style="margin-top:0px; margin-bottom:0px; background-color: #e8e8e8;">
<table align="center" width="100%" style="width: 100%;" >
<tbody>
<tr>
<td style="display:none; visibility:hidden;font-size:1px; color:#f4f4f4; line-height:1px; max-height:0px; max-width:0px; opacity:1; overflow:hidden;" align="center">Subscribe Now</td>
</tr>
<tr> 
<td align="center" class="hide" valign="top"><span style="font-family: Arial, Helvetica, sans-serif; font-size: 2px; color: #ffffff; font-weight: normal; visibility:hidden;"> &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;</span></td>
</tr>
<tr>
<td><table width="600" border="0" cellspacing="0" cellpadding="0" align="center" class="w100" style="border: 1px solid #333333;"  bgcolor="#ffffff">
<tbody>
<tr><td class="darkmode" style="padding: 20px 0px; font-size: 26px; line-height: 30px; font-family: Arial, Helvetica, sans-serif; text-align: center; font-weight: bold; background-color: #F5F5F5; color: #007BFF;">Srihari Muppalla</td></tr>
<tr>
<td>
<amp-accordion animate expand-single-section>
<section>
<h2 class="header"><span class="tog">Section 1</span></h2>
<div>
<table width="100%" border="0" cellspacing="0" cellpadding="0" align="center">
<tbody>
<tr>
<td align="center">
<amp-carousel height="300" width="500" type="slides" role="region" aria-label="Basic carousel" layout="responsive" controls loop autoplay delay="3000">
<a href="https:// srihari.site" target="_blank">
<amp-img src="https://placehold.co/600x300/000000/FFFFFF/png" width="500" height="300" layout="responsive" alt="BRINDA"></amp-img>
</a>
<a href="https:// srihari.site" target="_blank">
<amp-img src="https://placehold.co/600x300/007BFF/FFFFFF/png" width="500" height="300" layout="responsive" alt="ROLAND GARRO"></amp-img>
</a>
<a href="https:// srihari.site" target="_blank">
<amp-img src="https://placehold.co/600x300/ff0000/FFFFFF/png" width="500" height="300" layout="responsive" alt="Sony LIV Orignals"></amp-img>
</a>
</amp-carousel>
</td>
</tr>
</tbody>
</table>
</div> 
</section>
<section>
<h2 class="header"><span class="tog">Section 2</span></h2>
<div style="background-color: #000000;">
<table width="100%" border="0" cellspacing="0" cellpadding="0" style="padding: 10px;">
<tbody>
<tr>
<td align="left" style="padding-right: 10px;" class="mob">
<table  border="0" cellspacing="0" cellpadding="0" align="left">
<tbody>
<tr>
<td align="left" valign="top" width="100%" height="15" style="border-collapse:collapse; line-height: 15px;">
<!--[if gte mso 15]>&nbsp;<![endif]-->
</td>
</tr>
<tr>
<td align="center" valign="middle">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td width="20" valign="top" style="font-weight: bold; font-size: 24px; line-height: 26px; color: #ffffff;">&bull;</td>
<td valign="middle" class="outlookFallback" style="font-family: Arial; font-size: 16px; line-height: 24px; color: #ffffff; text-align: left;  font-weight: normal;">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="left" valign="top" width="100%" height="5" style="border-collapse:collapse; line-height: 5px;">
<!--[if gte mso 15]>&nbsp;<![endif]-->
</td>
</tr>
<tr>
<td align="center" valign="middle">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td width="20" valign="top" style="font-weight: bold; font-size: 24px; line-height: 26px;color: #ffffff;">&bull;</td>
<td valign="middle" class="outlookFallback" style="font-family: Arial; font-size: 16px; line-height: 24px; color: #ffffff; text-align: left;  font-weight: normal;">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="left" valign="top" width="100%" height="5" style="border-collapse:collapse; line-height: 5px;">
<!--[if gte mso 15]>&nbsp;<![endif]-->
</td>
</tr>
<tr>
<td align="center" valign="middle">
<table width="100%" border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td width="20" valign="top" style="font-weight: bold; font-size: 24px; line-height: 26px;color: #ffffff;">&bull;</td>
<td valign="middle" class="outlookFallback" style="font-family: Arial; font-size: 16px; line-height: 24px; color: #ffffff; text-align: left;  font-weight: normal;">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td align="left" valign="top" width="100%" height="22" style="border-collapse:collapse;  line-height: 22px;">
<!--[if gte mso 15]>&nbsp;<![endif]-->
</td>
</tr>
</tbody>
</table>
</td>
<td class="mob">
<table  border="0" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td>
<amp-img src="https://ik.imagekit.io/sriHari143/templates/amp/amp-card1_m57t1oGvAi.avif?updatedAt=1742542748012" width="300" height="300" layout="responsive" style="width:300px; height: 300px; border-radius:8px; " class="w100"></amp-img>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
</section>
<section expanded>
<h2 class="header"><span class="tog">Section 3</span></h2>
<div  style=" background-color: #EBAFC5; padding: 30px 0px;">
<table width="90%" border="0" cellspacing="0" cellpadding="0"  align="center">
<tbody>
<tr>
<td align="left" style="overflow: hidden;"><amp-img src="https://ik.imagekit.io/sriHari143/templates/amp/amp-card2_IfBlXKOof.jpg?updatedAt=1742542748094" width="300" height="300" layout="responsive" style="width:300px; height: 300px; border-radius: 24px; float:left;" class="sec3-img"></amp-img><span style=" font-size: 20px; ">Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</span>
</td>
</tr>
</tbody>
</table>
</div>
</section>
</amp-accordion>
</td>
</tr>
<tr>
<td bgcolor="#FFFFFF" style="text-align: center; font-size:18px; padding: 10px 0px; font-family:Lato,Arial,sans-serif; line-height:21px; height: 25px; color: #000000;" > Srihari Muppalla </td>
</tr>
</tbody>
</table></td>
</tr>
</tbody>
</table>
</body>
</html>

`;